module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_vm._v("\n        Alignment คือ Atomic Class ที่ใช้จัดการ Alignment สำหรับ Flex Layout และ Grid Layout\n        ทั้งในเรื่องของทิศทาง และการจัดวางในแนว Main-Axis (แนวเดียวกับทิศทาง) และ\n        Cross-Asix (แนวขวางกับทิศทาง) ประกอบไปด้วย\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-flex-direction"
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        ใช้สำหรับกำหนดทิศทางการจัดวางของ Flex Items\n      ")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-flex-wrap"
    }
  }), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        ใช้สำหรับกำหนดวิธีการ Wrap Flex items ด้านใน\n      ")]), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-flex"
    }
  }), _vm._v(" "), _vm._m(25), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        ใช้สำหรับกำหนดขนาดของตัว Flex item\n      ")]), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), _vm._m(33), _vm._v(" "), _vm._m(34), _vm._v(" "), _vm._m(35), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-align-items"
    }
  }), _vm._v(" "), _vm._m(36), _vm._v(" "), _vm._m(37), _vm._v(" "), _vm._m(38), _vm._v(" "), _vm._m(39), _vm._v(" "), _vm._m(40), _vm._v(" "), _vm._m(41), _vm._v(" "), _vm._m(42), _vm._v(" "), _vm._m(43), _vm._v(" "), _vm._m(44), _vm._v(" "), _vm._m(45), _vm._v(" "), _vm._m(46), _vm._v(" "), _vm._m(47), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-align-content"
    }
  }), _vm._v(" "), _vm._m(48), _vm._v(" "), _vm._m(49), _vm._v(" "), _vm._m(50), _vm._v(" "), _vm._m(51), _vm._v(" "), _vm._m(52), _vm._v(" "), _vm._m(53), _vm._v(" "), _vm._m(54), _vm._v(" "), _vm._m(55), _vm._v(" "), _vm._m(56), _vm._v(" "), _vm._m(57), _vm._v(" "), _vm._m(58), _vm._v(" "), _vm._m(59), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-align-self"
    }
  }), _vm._v(" "), _vm._m(60), _vm._v(" "), _vm._m(61), _vm._v(" "), _vm._m(62), _vm._v(" "), _vm._m(63), _vm._v(" "), _vm._m(64), _vm._v(" "), _vm._m(65), _vm._v(" "), _vm._m(66), _vm._v(" "), _vm._m(67), _vm._v(" "), _vm._m(68), _vm._v(" "), _vm._m(69), _vm._v(" "), _vm._m(70), _vm._v(" "), _vm._m(71), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'GettingStart'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  การใช้งาน\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicBackground'
      }
    }
  }, [_vm._v("\n            Background   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-alignment"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Alignment\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-128px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-flex-direction"
    }
  }, [_vm._v("Flex Direction")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-flex-wrap"
    }
  }, [_vm._v("Flex Wrap")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-flex"
    }
  }, [_vm._v("Flex")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-align-items"
    }
  }, [_vm._v("Align Items")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-align-items"
    }
  }, [_vm._v("Justify Items")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-align-content"
    }
  }, [_vm._v("Align Content")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-align-content"
    }
  }, [_vm._v("Justify Content")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-align-self"
    }
  }, [_vm._v("Align Self")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-align-self"
    }
  }, [_vm._v("Justify Self")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-flex-direction"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Flex Direction\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_fdrt-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("flex-direction")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_fdrt-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("r")]), _vm._v(" สำหรับ \"row\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("cl")]), _vm._v(" สำหรับ \"column\"\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Flex Direction")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Flex Direction – Row -->\n<div class=\"_dp-f _fdrt-r\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>\n\n<!-- Flex Direction – Column -->\n<div class=\"_dp-f _fdrt-cl\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-128px"
  }, [_c('div', [_vm._v("Row")]), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _fdrt-r _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")])]), _vm._v(" "), _c('div', [_vm._v("Column")]), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _fdrt-cl"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-flex-wrap"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Flex Wrap\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_fw-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("flex-wrap")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bio-message -primary _fs-6 _mgbt-32px"
  }, [_c('p', [_c('strong', [_vm._v("คำแนะนำ")]), _vm._v(" – flex-wrap ใช้ Class Name "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_fw-*")]), _vm._v(" เช่นเดียวกับ font-weight\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_fw-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("nw")]), _vm._v(" สำหรับ \"nowrap\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("w")]), _vm._v(" สำหรับ \"wrap\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("wrv")]), _vm._v(" สำหรับ \"wrap-reverse\"\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Flex Wrap")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Wrap -->\n<div class=\"_dp-f _fw-w\">\n  <div class=\"_w-50pct\">item 1</div>\n  <div class=\"_w-50pct\">item 2</div>\n  <div class=\"_w-50pct\">item 3</div>\n  <div class=\"_w-50pct\">item 4</div>\n</div>\n\n<!-- No Wrap -->\n<div class=\"_dp-f _fw-nw\">\n  <div class=\"_w-50pct\">item 1</div>\n  <div class=\"_w-50pct\">item 2</div>\n  <div class=\"_w-50pct\">item 3</div>\n  <div class=\"_w-50pct\">item 4</div>\n</div>\n\n<!-- Wrap Reverse -->\n<div class=\"_dp-f _fw-wrv\">\n  <div class=\"_w-50pct\">item 1</div>\n  <div class=\"_w-50pct\">item 2</div>\n  <div class=\"_w-50pct\">item 3</div>\n  <div class=\"_w-50pct\">item 4</div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-128px"
  }, [_vm._v("\n        Wrap\n        "), _c('div', {
    staticClass: "_dp-f _fw-w _h-64px _mgbt-32px _bdw-2px _bgcl-neutral-400"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _w-50pct _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item 1")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _w-50pct _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item 2")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _w-50pct _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item 3")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _w-50pct _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item 4")])]), _vm._v("\n        No Wrap\n        "), _c('div', {
    staticClass: "_dp-f _fw-nw _h-64px _mgbt-32px _bdw-2px _bgcl-neutral-400"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _w-50pct _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item 1")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _w-50pct _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item 2")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _w-50pct _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item 3")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _w-50pct _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item 4")])]), _vm._v("\n        Wrap Reverse\n        "), _c('div', {
    staticClass: "_dp-f _fw-wrv _h-64px _mgbt-8px _bdw-2px _bgcl-neutral-400"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _w-50pct _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item 1")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _w-50pct _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item 2")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _w-50pct _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item 3")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _w-50pct _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item 4")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-flex"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Flex\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_f-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("flex")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_f-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("1")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("2")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("3")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("4")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("5")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("6")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("7")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("8")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("9")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Flex Wrap")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Flex -->\n<div class=\"_dp-f\">\n  <div class=\"_f-1\">flex 1</div>\n</div>\n\n<div class=\"_dp-f\">\n  <div class=\"_f-1\">flex 1</div>\n  <div class=\"_f-1\">flex 1</div>\n</div>\n\n<div class=\"_dp-f\">\n  <div class=\"_f-1\">flex 1</div>\n  <div class=\"_f-4\">flex 4</div>\n</div>\n\n<div class=\"_dp-f\">\n  <div class=\"_f-1\">flex 1</div>\n  <div class=\"_f-4\">flex 4</div>\n  <div class=\"_f-1\">flex 1</div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-128px"
  }, [_c('div', {
    staticClass: "_dp-f _h-64px _mgbt-16px _bdw-2px _bgcl-neutral-400"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _f-1 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("flex 1")])]), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _h-64px _mgbt-16px _bdw-2px _bgcl-neutral-400"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _f-1 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("flex 1")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _f-1 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("flex 1")])]), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _h-64px _mgbt-16px _bdw-2px _bgcl-neutral-400"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _f-1 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("flex 1")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _f-4 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("flex 4")])]), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _h-64px _mgbt-8px _bdw-2px _bgcl-neutral-400"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _f-1 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("flex 1")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _f-4 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("flex 4")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _f-1 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("flex 1")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-align-items"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Align Items, Justify Items\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        เป็น Atomic Class ที่ใช้จัดการ Alignment ของ Flex Items ด้านใน Flex Container "), _c('br'), _vm._v("\n        ใช้ Align Items เพื่อจัดในแกน Cross-Axis "), _c('br'), _vm._v("\n        ใช้ Justify Items เพื่อจัดในแกน Main-Axis\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_alit-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("align-items")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_jtfit-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("justify-items")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_alit-*")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_jtfit-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("st")]), _vm._v(" สำหรับ \"start\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("e")]), _vm._v(" สำหรับ \"end\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("fst")]), _vm._v(" สำหรับ \"flex-start\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("fe")]), _vm._v(" สำหรับ \"flex-end\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("ct")]), _vm._v(" สำหรับ \"center\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("str")]), _vm._v(" สำหรับ \"strecth\"\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Align Items")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Align Items of Flex Row -->\n<div class=\"_dp-f _alit-ct\">\n  <div>item</div>\n</div>\n<div class=\"_dp-f _alit-fst\">\n  <div>item</div>\n</div>\n<div class=\"_dp-f _alit-fe\">\n  <div>item</div>\n</div>\n<div class=\"_dp-f _alit-str\">\n  <div>item</div>\n</div>\n\n<!-- Align Items of Flex Column -->\n<div class=\"_dp-f _fdrt-cl _alit-ct\">\n  <div>item</div>\n</div>\n<div class=\"_dp-f _fdrt-cl _alit-fst\">\n  <div>item</div>\n</div>\n<div class=\"_dp-f _fdrt-cl _alit-fe\">\n  <div>item</div>\n</div>\n<div class=\"_dp-f _fdrt-cl _alit-str\">\n  <div>item</div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-128px"
  }, [_c('div', {
    staticClass: "_dp-f _h-64px _alit-ct _bdw-2px _bdcl-neutral-400 _mgbt-8px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")])]), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _h-64px _alit-fst _bdw-2px _bdcl-neutral-400 _mgbt-8px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")])]), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _h-64px _alit-fe _bdw-2px _bdcl-neutral-400 _mgbt-8px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")])]), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _h-64px _alit-str _bdw-2px _bdcl-neutral-400 _mgbt-32px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")])]), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _fdrt-cl _h-64px _alit-ct _bdw-2px _bdcl-neutral-400 _mgbt-8px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")])]), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _fdrt-cl _h-64px _alit-fst _bdw-2px _bdcl-neutral-400 _mgbt-8px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")])]), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _fdrt-cl _h-64px _alit-fe _bdw-2px _bdcl-neutral-400 _mgbt-8px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")])]), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _fdrt-cl _h-64px _alit-str _bdw-2px _bdcl-neutral-400 _mgbt-8px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-align-content"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Align Content, Justify Content\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        เป็น Atomic Class ที่ใช้จัดการ การกระจาย Content ด้านใน Container "), _c('br'), _vm._v("\n        ใช้ Align Content เพื่อจัดในแกน Cross-Axis "), _c('br'), _vm._v("\n        ใช้ Justify Content เพื่อจัดในแกน Main-Axis\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_alct-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("align-content")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_jtfct-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("justify-content")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_alct-*")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_jtfct-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("st")]), _vm._v(" สำหรับ \"start\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("e")]), _vm._v(" สำหรับ \"end\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("l")]), _vm._v(" สำหรับ \"left\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("r")]), _vm._v(" สำหรับ \"right\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("fst")]), _vm._v(" สำหรับ \"flex-start\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("fe")]), _vm._v(" สำหรับ \"flex-end\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("str")]), _vm._v(" สำหรับ \"stretch\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("spbtw")]), _vm._v(" สำหรับ \"space-between\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("spar")]), _vm._v(" สำหรับ \"space-around\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("spevl")]), _vm._v(" สำหรับ \"space-evenly\"\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Justify Content")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Center -->\n<div class=\"_dp-f _jtfct-ct\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>\n\n<!-- Flex Start -->\n<div class=\"_dp-f _jtfct-fst\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>\n\n<!-- Flex End -->\n<div class=\"_dp-f _jtfct-fe\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>\n\n<!-- Space Between -->\n<div class=\"_dp-f _jtfct-spbtw\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>\n\n<!-- Space Around -->\n<div class=\"_dp-f _jtfct-spar\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>\n\n<!-- Space Evenly -->\n<div class=\"_dp-f _jtfct-spevl\">\n  <div>item</div>\n  <div>item</div>\n  <div>item</div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-128px"
  }, [_vm._v("\n        Center\n        "), _c('div', {
    staticClass: "_dp-f _h-64px _jtfct-ct _bdw-2px _bdcl-neutral-400 _mgbt-12px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")])]), _vm._v("\n        Flex Start\n        "), _c('div', {
    staticClass: "_dp-f _h-64px _jtfct-fst _bdw-2px _bdcl-neutral-400 _mgbt-12px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")])]), _vm._v("\n        Flex End\n        "), _c('div', {
    staticClass: "_dp-f _h-64px _jtfct-fe _bdw-2px _bdcl-neutral-400 _mgbt-12px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")])]), _vm._v("\n        Space Between\n        "), _c('div', {
    staticClass: "_dp-f _h-64px _jtfct-spbtw _bdw-2px _bdcl-neutral-400 _mgbt-12px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")])]), _vm._v("\n        Space Around\n        "), _c('div', {
    staticClass: "_dp-f _h-64px _jtfct-spar _bdw-2px _bdcl-neutral-400 _mgbt-12px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")])]), _vm._v("\n        Space Evenly\n        "), _c('div', {
    staticClass: "_dp-f _h-64px _jtfct-spevl _bdw-2px _bdcl-neutral-400 _mgbt-8px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-align-self"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Align Self, Justify Self\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        เป็น Atomic Class ที่ใช้เพื่อระบุการจัดวางของตัว Flex Item เอง"), _c('br'), _vm._v("\n        ใช้ Align Self เพื่อจัดในแกน Cross-Axis "), _c('br'), _vm._v("\n        ใช้ Justify Self เพื่อจัดในแกน Main-Axis\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_als-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("align-self")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_jtfs-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("justify-self")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_als-*")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_jtfs-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("st")]), _vm._v(" สำหรับ \"start\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("e")]), _vm._v(" สำหรับ \"end\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("l")]), _vm._v(" สำหรับ \"left\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("r")]), _vm._v(" สำหรับ \"right\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("fst")]), _vm._v(" สำหรับ \"flex-start\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("fe")]), _vm._v(" สำหรับ \"flex-end\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("sst")]), _vm._v(" สำหรับ \"self-start\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("se")]), _vm._v(" สำหรับ \"self-end\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("str")]), _vm._v(" สำหรับ \"stretch\" "), _c('br')])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Align Self")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Center -->\n<div class=\"_dp-f\">\n  <div>item 1</div>\n  <div class=\"_als-fst\">item 2</div>\n  <div class=\"_als-ct\">item 3</div>\n  <div class=\"_als-fe\">item 4</div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "_dp-f _h-64px _bdw-2px _bdcl-neutral-400 _mgbt-12px"
  }, [_c('div', {
    staticClass: "_bgcl-neutral-300 _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item 1")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _als-fst _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item 2")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _als-ct _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item 3")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _als-fe _bdw-2px _bdcl-neutral-700"
  }, [_vm._v("item 4")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8c072f8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/document-pages/AtomicAlignment.vue
// module id = 140
// module chunks = 0